/**
 * Deter casual DevTools use when REACT_APP_ENVIRONMENT=production or NODE_ENV=production.
 * Not a security boundary — server-side auth remains authoritative.
 */
const DEVTOOLS_DOCK_GAP_PX = 160;

function isProductionEnvironment(): boolean {
  if (process.env.NODE_ENV === 'production') return true;
  return (process.env.REACT_APP_ENVIRONMENT || '').toLowerCase() === 'production';
}

function blockKeyboardShortcuts(event: KeyboardEvent): void {
  const key = event.key.toLowerCase();

  if (key === 'f12') {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  const ctrlOrMeta = event.ctrlKey || event.metaKey;
  const shift = event.shiftKey;
  const alt = event.altKey;

  if (
    (ctrlOrMeta && shift && ['i', 'j', 'c'].includes(key)) ||
    (ctrlOrMeta && alt && ['i', 'j', 'c'].includes(key)) ||
    (ctrlOrMeta && key === 'u') ||
    (event.metaKey && alt && key === 'u')
  ) {
    event.preventDefault();
    event.stopPropagation();
  }
}

function showDevToolsBlockedOverlay(): void {
  if (document.getElementById('tp-devtools-blocked')) return;

  const overlay = document.createElement('div');
  overlay.id = 'tp-devtools-blocked';
  overlay.setAttribute('role', 'alert');
  overlay.style.cssText =
    'position:fixed;inset:0;z-index:2147483647;background:#0f172a;color:#f8fafc;' +
    'display:flex;align-items:center;justify-content:center;padding:24px;text-align:center;' +
    'font-family:system-ui,sans-serif;';
  overlay.innerHTML =
    '<div><h1 style="font-size:1.25rem;font-weight:700;margin:0 0 8px">Developer tools disabled</h1>' +
    '<p style="margin:0;opacity:0.85;font-size:0.95rem">Close developer tools to continue.</p></div>';

  document.body.appendChild(overlay);
}

function isDevToolsDockOpen(): boolean {
  return (
    window.outerWidth - window.innerWidth > DEVTOOLS_DOCK_GAP_PX ||
    window.outerHeight - window.innerHeight > DEVTOOLS_DOCK_GAP_PX
  );
}

function startDevToolsDockGuard(): void {
  const inspect = () => {
    if (isDevToolsDockOpen()) showDevToolsBlockedOverlay();
  };

  window.setInterval(inspect, 500);
  window.addEventListener('resize', inspect);
  inspect();
}

export function initProductionHardening(): void {
  if (!isProductionEnvironment()) return;

  document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  document.addEventListener('keydown', blockKeyboardShortcuts, true);
  startDevToolsDockGuard();
}
